import { gql } from '@apollo/client';

export interface RemoveProfessorFromCourseMutationVariables {
  courseId: string;
  professorId: string;
}

export interface RemoveProfessorFromCourseMutationResult {
  courseProfessor: {
    id: string;
  };
}

export const removeProfessorFromCourseMutation = gql`
  mutation RemoveProfessorFromCourseMutation($courseId: String!, $professorId: String!) {
    courseProfessor(courseId: $courseId, professorId: $professorId)
      @rest(type: "CourseProfessor", path: "courses/{args.courseId}/professors/{args.professorId}", method: "DELETE") {
      id: _id
    }
  }
`;
